import DataModel from "./DataModel";
import Id from "./Id";

class AdministerableDataModel  extends DataModel {
  admins: Id[] = [];
}

export default AdministerableDataModel;